import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 mx-2 my-4" }
const _hoisted_2 = { class: "flex flex-col gap-12 h-full my-2 pb-12 mx-[2%] lg:mx-[10%] 2xl:mx-[20%]" }
const _hoisted_3 = { class: "flex flex-col h-full gap-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-primary text-center font-semibold text-xl pb-4" }, " Registrar residente ", -1)
const _hoisted_5 = { class: "text-lg text-center font-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold" }, "Datos personales", -1)
const _hoisted_7 = { class: "grid sm:grid-cols-2 lg:grid-cols-3 gap-8" }
const _hoisted_8 = { class: "flex flex-col gap-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "text-xs" }, "Profesión"),
  /*#__PURE__*/_createElementVNode("label", { class: "text-red-500 text-xs" }, " * ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  disabled: "",
  value: ""
}, " Seleccione una profesión ", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "flex flex-col gap-4 col-span-2 lg:col-span-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-md font-semibold text-md" }, "Dirección"),
  /*#__PURE__*/_createElementVNode("label", { class: "text-red-500" }, " * ")
], -1)
const _hoisted_14 = { class: "flex flex-row gap-2" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "col-span-2 sm:col-span-1 flex flex-col gap-2 w-full" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h1", { class: "text-md font-semibold text-md" }, "Bodegas", -1)
const _hoisted_18 = { class: "flex flex-col gap-2" }
const _hoisted_19 = { class: "flex flex-row items-center gap-2" }
const _hoisted_20 = { class: "col-span-2 sm:col-span-1 flex flex-col gap-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h1", { class: "text-md font-semibold text-md" }, "Estacionamientos", -1)
const _hoisted_22 = { class: "flex flex-col gap-2" }
const _hoisted_23 = { class: "flex flex-row items-center gap-2" }
const _hoisted_24 = { class: "flex flex-col gap-4 col-span-2 lg:col-span-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h1", { class: "text-md font-semibold text-md" }, "Vehiculos", -1)
const _hoisted_26 = { class: "flex flex-row gap-1 items-center" }
const _hoisted_27 = { class: "col-span-2 flex flex-col gap-4 lg:col-span-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h1", { class: "text-md font-semibold text-md" }, "Mascotas", -1)
const _hoisted_29 = { class: "flex flex-col sm:flex-row justify-between items-center gap-4" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "sm:hidden" }, "Agregar", -1)
const _hoisted_32 = { class: "flex flex-col gap-2 p-4 bg-gray-100 rounded-lg" }
const _hoisted_33 = {
  key: 0,
  class: "font-semibold text-gray-800"
}
const _hoisted_34 = { class: "flex flex-row gap-4 w-full items-center justify-between" }
const _hoisted_35 = { class: "flex flex-row items-center gap-4" }
const _hoisted_36 = { class: "text-sm font-gray-600" }
const _hoisted_37 = { class: "flex flex-col gap-4 col-span-2 lg:col-span-3" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h1", { class: "text-md font-semibold text-md" }, "Discapacidad", -1)
const _hoisted_39 = { class: "flex flex-row justify-between items-center gap-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-semibold text-gray-700" }, "¿Tiene capacidad reducida?", -1)
const _hoisted_41 = {
  key: 0,
  class: "flex flex-col gap-1 w-full"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "text-xs" }, "Capacidad Reducida", -1)
const _hoisted_43 = ["disabled"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "Seleccione una discapacidad", -1)
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "flex flex-col gap-4 col-span-2 lg:col-span-3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold" }, "Contraseña de usuario", -1)
const _hoisted_48 = { class: "ml-auto pb-12" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = { key: 0 }
const _hoisted_51 = {
  key: 1,
  class: "icon-spin"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1)
const _hoisted_53 = [
  _hoisted_52
]

import { ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";

import {
  validateEmailStructure,
  verifyPhoneNumberFormat,
} from "@/services/auth/AuthUtils";

import { swal as Swal, alert } from "@/configs/swal";

import inputChipAuxSimpler from "@/components/general/molecules/inputChipSimpler.vue";
import inputChipAuxVue from "@/components/general/molecules/inputChipAux.vue";
import TextField from "@/components/general/atoms/TextField.vue";
import Selector from "@/components/general/atoms/SelectorObj.vue";
import Switch from "@/components/general/atoms/Switch.vue";
import { PublicService } from "@/services/public/publicService";

import { petTypes } from "@/constants/enums";
import { extractErrorMessage, validateRut } from "@/services/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResidentRegisterPublic',
  setup(__props) {

const router = useRouter();

const publicService = new PublicService();

const route = useRoute();

const formUUID = computed(() => route.params.formUUID);

const selectorData = ref();

const setForm = () => {
  return {
    user_info: {
      first_name: "",
      last_name: "",
      last_name_second: "",
      profession: "",
      age: 0,
      phone: "",
      has_reduced_capacity: false,
      reduced_capacity_details: "",
      email: "",
      dni: "",
      rut: "",
      password: "",
      re_password: "",
    },
    community_user_info: {
      position: "",
      user_id: undefined,
      user_role: 1,
      is_active: true,
      is_committee_member: false,
      commmittee_position: "",
      is_fab: false,
      community_id: 0,
    },
    units_info: [],
    warehouses: [],
    parking_spots: [],
    vehicles: [],
  };
};

const newForm = ref(setForm());

const professionList = ref<Array<string>>([]);
const rcList = ref<Array<string>>([]);

const warehouseInput = ref();
const parkingInput = ref();
const vehicleInput = ref();

const petInput = ref<object>({
  id: undefined,
  type_id: undefined,
  type_name: undefined,
  quantity: 1,
  unit_id: undefined,
});

const unitInput = ref<object>({
  id: undefined,
  name: undefined,
  floor: 1,
  address: undefined,
  establishment_type: 0,
  block_id: 0,
  pets: [],
});

const loading = ref<boolean>(false);

const hasPhoneError = ref<boolean>(false);
const hasEmailError = ref<boolean>(false);

const isFieldsFilled = computed(() => {

  return (
    newForm.value.user_info.first_name &&
    newForm.value.user_info.last_name &&
    newForm.value.user_info.last_name_second &&
    newForm.value.user_info.phone &&
    newForm.value.user_info.dni &&
    newForm.value.user_info.email &&
    newForm.value.user_info.password.trim() != "" &&
    newForm.value.user_info.password === newForm.value.user_info.re_password &&
    newForm.value.units_info.length > 0
  );
});

const addUnit = () => {
  if (
    unitInput.value &&
    !newForm.value.units_info.some((unit) => unit.id == unitInput.value.id)
  ) {
    newForm.value.units_info.push({ ...unitInput.value });
  }
};

const dropUnit = (item: any) => {
  if (item) {
    newForm.value.units_info = [
      ...newForm.value.units_info.filter((unit) => unit.id !== item.id),
    ];
  }
};

const addWareHouse = () => {
  if (
    newForm.value.units_info.length > 0 &&
    warehouseInput.value &&
    !newForm.value.warehouses.some((ware) => ware.id == warehouseInput.value.id)
  ) {
    newForm.value.warehouses.push(warehouseInput.value);
    warehouseInput.value = "";
  }
};

const dropWareHouse = (item: any) => {
  if (item) {
    newForm.value.warehouses = [
      ...newForm.value.warehouses.filter((unit) => unit.id !== item.id),
    ];
  }
};

const addParking = () => {
  if (
    newForm.value.units_info.length > 0 &&
    parkingInput.value &&
    !newForm.value.parking_spots.some(
      (parkingSpot) => parkingSpot.id == parkingInput.value.id
    )
  ) {
    newForm.value.parking_spots.push(parkingInput.value);
    parkingInput.value = "";
  }
};

const dropParking = (item: any) => {
  if (item) {
    newForm.value.parking_spots = [
      ...newForm.value.parking_spots.filter(
        (parkingSpot) => parkingSpot.id !== item.id
      ),
    ];
  }
};

const addVehicle = () => {
  if (
    vehicleInput.value &&
    !newForm.value.vehicles.some((vehicle) => vehicle == vehicleInput.value)
  ) {
    newForm.value.vehicles.push(vehicleInput.value);
    vehicleInput.value = "";
  }
};

const dropVehicle = (itemIndex: number) =>
  newForm.value.vehicles.splice(itemIndex, 1);

const addPet = () => {
  if (petInput.value) {
    newForm.value?.units_info.find((unit) => {
      if (unit.id === petInput.value.unit_id) {
        unit.pets.push({
          type: +petInput.value.type_id,
          quantity: petInput.value.quantity,
          id: newForm.value.id ?? null,
        });
      }
    });
    // Then we clear the input
  }
};

const dropPet = (petIndex: number) => {
  newForm.value.units_info.find((unit) => {
    if (unit.id === petInput.value.unit_id) {
      unit.pets.splice(petIndex, 1);
    }
  });
};

const createUser = async () => {
  try {
    const { success, data } = await publicService.createResident(
      formUUID.value,
      newForm.value
    );

    if (success) {
      await alert.fire({
        icon: "success",
        title: "Registrar residente",
        text: "Residente creado exitosamente.",
      });

      router.replace({ name: "register-resident-success" });
    } else {
      const msg = extractErrorMessage(data.message);
      alert.fire({
        icon: "error",
        title: "Error",
        text: msg,
      });
    }
  } catch (err) {
    console.error(err);
    alert.fire({
      icon: "error",
      title: "Error",
      text: "Oops, tuvimos un error.",
    });
  }
};

const fetchSelectorData = async () => {
  try {
    const { data } = await publicService.fetchCommunityAvailableData(
      formUUID.value
    );

    if (data) selectorData.value = { ...data };
  } catch (err) {
    console.error(err);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Oops, tuvimos un error.",
    });
  }
};

const getResidentFilterOptions = async () => {
  try {
    const { data: professionData } =
      await publicService.getResidentProfessions();
    const { data: rcData } = await publicService.getResidentReducedCapacity();

    if (professionData?.data) professionList.value = [...professionData.data];

    if (rcData?.data) rcList.value = [...rcData.data];
  } catch (err) {
    alert.fire({
      icon: "error",
      title: "Error",
      text: "Hubo un error al obtener el listado de opciones de filtro.",
    });
  }
};

onMounted(async () => {
  await getResidentFilterOptions();
  await fetchSelectorData();
});

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("h1", _hoisted_5, _toDisplayString(selectorData.value?.community?.name ?? "-"), 1),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(TextField, {
            class: "col-span-2 sm:col-span-1",
            label: "Nombre",
            model: newForm.value.user_info.first_name,
            "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((newForm.value.user_info.first_name) = $event)),
            type: "text",
            name: "descripcion",
            placeholder: "Juan",
            required: ""
          }, null, 8, ["model"]),
          _createVNode(TextField, {
            class: "col-span-2 sm:col-span-1",
            label: "Primer Apellido",
            model: newForm.value.user_info.last_name,
            "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((newForm.value.user_info.last_name) = $event)),
            type: "text",
            name: "apellido",
            placeholder: "Perez",
            required: ""
          }, null, 8, ["model"]),
          _createVNode(TextField, {
            class: "col-span-2 sm:col-span-1",
            label: "Segundo Apellido",
            model: newForm.value.user_info.last_name_second,
            "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((newForm.value.user_info.last_name_second) = $event)),
            type: "text",
            name: "apellido",
            placeholder: "García",
            required: ""
          }, null, 8, ["model"]),
          _createVNode(TextField, {
            class: "col-span-2 sm:col-span-1",
            label: "RUT",
            model: newForm.value.user_info.dni,
            "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((newForm.value.user_info.dni) = $event)),
            type: "text",
            name: "rut",
            placeholder: "12345678-9",
            required: "",
            hasError: 
              !_unref(validateRut)(newForm.value.user_info.dni) && newForm.value.user_info.dni != ''
            ,
            "error-message": "RUT Inválido"
          }, null, 8, ["model", "hasError"]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newForm.value.user_info.profession) = $event))
            }, [
              _hoisted_10,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(professionList.value, (profession) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: profession,
                  value: profession
                }, _toDisplayString(profession), 9, _hoisted_11))
              }), 128))
            ], 512), [
              [_vModelSelect, newForm.value.user_info.profession]
            ])
          ]),
          _createVNode(TextField, {
            class: "col-span-2 sm:col-span-1",
            label: "Correo electrónico",
            name: "email",
            type: "string",
            model: newForm.value.user_info.email,
            "onUpdate:model": [
              _cache[5] || (_cache[5] = ($event: any) => ((newForm.value.user_info.email) = $event)),
              _cache[6] || (_cache[6] = (value) => {
            !_unref(validateEmailStructure)(value) ? hasEmailError.value = true : hasEmailError.value = false;
        })
            ],
            "has-error": hasEmailError.value,
            placeholder: 'ejemplo@gmail.com',
            required: "",
            "error-message": 
              newForm.value.user_info.email &&
              newForm.value.user_info.email.trim().length === 0
                ? 'El correo electrónico está vacío'
                : 'Correo electrónico no válido. Verifique que no esté mal escrito'
            
          }, null, 8, ["model", "has-error", "placeholder", "error-message"]),
          _createVNode(TextField, {
            class: "col-span-2 sm:col-span-1",
            label: "Teléfono",
            model: newForm.value.user_info.phone,
            "onUpdate:model": [
              _cache[7] || (_cache[7] = ($event: any) => ((newForm.value.user_info.phone) = $event)),
              _cache[8] || (_cache[8] = (value) => {
            !_unref(verifyPhoneNumberFormat)(value) ? hasPhoneError.value = true : hasPhoneError.value = false;
        })
            ],
            type: "text",
            name: "Telefono",
            placeholder: "+569xxxxxxxx",
            "has-error": hasPhoneError.value,
            required: "",
            "error-message": 
              newForm.value.user_info.phone &&
              newForm.value.user_info.phone.trim().length === 0
                ? 'El telefono está vacío'
                : 'El telefono no es válido. Verifique que no esté mal escrito'
            
          }, null, 8, ["model", "has-error", "error-message"]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(Selector, {
                items: selectorData.value?.residences,
                selectedItem: unitInput.value,
                placeholder: "Seleccione un block",
                labelValue: "name",
                keyValue: "id",
                onUpdate: _cache[9] || (_cache[9] = (value) => {
                    unitInput.value.id = +value?.id;
                    unitInput.value.name = value?.name;
                    unitInput.value.floor = value?.floor;
                    unitInput.value.address = value?.address;
                    unitInput.value.establishment_type = value?.establishment_type;
                    unitInput.value.block_id = value?.block_id;
                    unitInput.value.pets = [];

                    addUnit()
                  })
              }, null, 8, ["items", "selectedItem"]),
              _createElementVNode("button", {
                class: "flex flex-row items-center",
                disabled: !unitInput.value.id,
                onClick: _cache[10] || (_cache[10] = ($event: any) => (addUnit()))
              }, [
                _createVNode(_component_mdicon, {
                  name: "plus-circle-outline",
                  class: "hover:cursor-pointer flex flex-col justify-end"
                })
              ], 8, _hoisted_15)
            ]),
            _createVNode(inputChipAuxSimpler, {
              array: newForm.value.units_info,
              labelValue: "name",
              keyValue: "id",
              onDrop: _cache[11] || (_cache[11] = (value) => dropUnit(value))
            }, null, 8, ["array"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(Selector, {
                  "its-disabled": newForm.value.units_info.length == 0,
                  items: selectorData.value?.wineries,
                  selectedItem: warehouseInput.value,
                  placeholder: "Seleccione una bodega",
                  labelValue: "description",
                  keyValue: "id",
                  onUpdate: _cache[12] || (_cache[12] = (value) => {
                    warehouseInput.value = value
                    addWareHouse()
                    })
                }, null, 8, ["its-disabled", "items", "selectedItem"]),
                _createVNode(_component_mdicon, {
                  name: "plus-circle-outline",
                  class: "hover:cursor-pointer",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (addWareHouse()))
                })
              ]),
              _createVNode(inputChipAuxSimpler, {
                array: newForm.value.warehouses,
                labelValue: "description",
                keyValue: "id",
                onDrop: _cache[14] || (_cache[14] = (value) => dropWareHouse(value))
              }, null, 8, ["array"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(Selector, {
                  "its-disabled": newForm.value.units_info.length == 0,
                  items: selectorData.value?.parkingSpots,
                  selectedItem: parkingInput.value,
                  labelValue: "description",
                  keyValue: " id",
                  placeholder: "Seleccione un estacionamiento",
                  onUpdate: _cache[15] || (_cache[15] = (value) => {
                    parkingInput.value = value
                    addParking()
                    })
                }, null, 8, ["its-disabled", "items", "selectedItem"]),
                _createVNode(_component_mdicon, {
                  name: "plus-circle-outline",
                  class: "hover:cursor-pointer",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (addParking()))
                })
              ]),
              _createVNode(inputChipAuxSimpler, {
                array: newForm.value.parking_spots,
                onDrop: _cache[17] || (_cache[17] = (item) => dropParking(item)),
                labelValue: "description",
                keyValue: "id"
              }, null, 8, ["array"])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createVNode(TextField, {
                disabled: newForm.value.units_info.length == 0,
                model: vehicleInput.value,
                "onUpdate:model": _cache[18] || (_cache[18] = ($event: any) => ((vehicleInput).value = $event)),
                label: "Patente",
                type: "text",
                name: "vehicle",
                placeholder: 'XG-CG-13',
                class: "w-full md:w-1/4 lg:w-1/4",
                "hide-details": "",
                onChange: _cache[19] || (_cache[19] = ($event: any) => (addVehicle()))
              }, null, 8, ["disabled", "model"]),
              _createElementVNode("button", {
                class: "hover:cursor-pointer mt-4",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (addVehicle()))
              }, [
                _createVNode(_component_mdicon, { name: "plus-circle-outline" })
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(inputChipAuxVue, {
                itemParameter: "vehicle",
                array: newForm.value.vehicles,
                onDrop: dropVehicle,
                compact: true,
                class: ""
              }, null, 8, ["array"])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createVNode(Selector, {
                "its-disabled": 
                  !petInput.value?.type_id && !newForm.value.units_info.length > 0
                ,
                items: newForm.value.units_info,
                label: "Establecimiento",
                labelValue: "name",
                keyValue: "id",
                onUpdate: _cache[21] || (_cache[21] = (value) => {
                    petInput.value.unit_id = +value.id;
                })
              }, null, 8, ["its-disabled", "items"]),
              _createVNode(Selector, {
                "its-disabled": 
                  !petInput.value?.type_id && !newForm.value.units_info.length > 0
                ,
                items: _unref(petTypes),
                label: "Tipo",
                onUpdate: _cache[22] || (_cache[22] = (val) => {
                petInput.value.type_id = val.value;
                petInput.value.type_name = val.label;
            }),
                labelValue: "label",
                keyValue: "value"
              }, null, 8, ["its-disabled", "items"]),
              _createVNode(TextField, {
                disabled: newForm.value?.units_info.length == 0,
                model: petInput.value.quantity,
                "onUpdate:model": _cache[23] || (_cache[23] = ($event: any) => ((petInput.value.quantity) = $event)),
                type: "number",
                label: "Cantidad",
                name: "petQuantity",
                class: "w-full md:w-1/4 lg:w-1/4",
                "hide-details": "",
                min: 1,
                max: 1000
              }, null, 8, ["disabled", "model"]),
              _createElementVNode("button", {
                class: "flex flex-row items-center gap-2 mx-auto",
                disabled: !petInput.value?.type_id && !newForm.value.units_info.length > 0,
                onClick: _cache[24] || (_cache[24] = ($event: any) => (addPet()))
              }, [
                _createVNode(_component_mdicon, {
                  name: "plus-circle-outline",
                  class: "hover:cursor-pointer sm:mt-4"
                }),
                _hoisted_31
              ], 8, _hoisted_30)
            ]),
            _createElementVNode("div", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newForm.value.units_info, (unit) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex flex-col gap-1",
                  key: unit.id
                }, [
                  (unit.pets?.length > 0)
                    ? (_openBlock(), _createElementBlock("h1", _hoisted_33, _toDisplayString(unit.name), 1))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unit.pets, (pet, petIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "flex flex-col gap-1 pr-2",
                      key: petIndex
                    }, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", null, _toDisplayString(_unref(petTypes)[pet.type - 1]?.label), 1),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, " Cantidad " + _toDisplayString(pet.quantity), 1),
                          _createVNode(_component_mdicon, {
                            name: "close",
                            class: "hover:cursor-pointer",
                            onClick: ($event: any) => (dropPet(petIndex, unit.id))
                          }, null, 8, ["onClick"])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createVNode(Switch, {
                actived: newForm.value.user_info.has_reduced_capacity,
                name: "has_reduced_capacity",
                "onUpdate:actived": _cache[25] || (_cache[25] = 
                  () => {
                    newForm.value.user_info.has_reduced_capacity =
                      !newForm.value.user_info.has_reduced_capacity;
                    newForm.value.user_info.reduced_capacity_details = '';
                  }
                )
              }, null, 8, ["actived"])
            ]),
            (newForm.value.user_info.has_reduced_capacity)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _hoisted_42,
                  _withDirectives(_createElementVNode("select", {
                    disabled: !newForm.value.user_info.has_reduced_capacity,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((newForm.value.user_info.reduced_capacity_details) = $event))
                  }, [
                    _hoisted_44,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rcList.value, (rc) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: rc,
                        value: rc
                      }, _toDisplayString(rc), 9, _hoisted_45))
                    }), 128))
                  ], 8, _hoisted_43), [
                    [_vModelSelect, newForm.value.user_info.reduced_capacity_details]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _createVNode(TextField, {
              name: "password",
              class: "sm:w-48",
              label: "Contraseña",
              type: "password",
              required: "",
              model: newForm.value.user_info.password,
              "onUpdate:model": _cache[27] || (_cache[27] = ($event: any) => ((newForm.value.user_info.password) = $event))
            }, null, 8, ["model"]),
            _createVNode(TextField, {
              name: "password_confirm",
              label: "Confirmar Contraseña",
              class: "sm:w-48",
              type: "password",
              required: "",
              model: newForm.value.user_info.re_password,
              "onUpdate:model": _cache[28] || (_cache[28] = ($event: any) => ((newForm.value.user_info.re_password) = $event))
            }, null, 8, ["model"])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("button", {
            class: _normalizeClass(["px-4 py-2 cursor-pointer rounded-md bg-primary text-white hover:bg-green-600 focus:bg-green-600", {
              'opacity-50 cursor-not-allowed disabled:pointer-events-none':
                !_unref(isFieldsFilled),
            }]),
            disabled: !_unref(isFieldsFilled) || loading.value,
            onClick: _cache[29] || (_cache[29] = ($event: any) => (createUser()))
          }, [
            (!loading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_50, " Agregar "))
              : (_openBlock(), _createElementBlock("span", _hoisted_51, _hoisted_53))
          ], 10, _hoisted_49)
        ])
      ])
    ])
  ]))
}
}

})